<template>
  <div id="motmpanel" class="container row text-center">
    <div class="col-md-12 col-lg-6 d-lg-flex flex-lg-column justify-content-center">
      <h3>Chris Gayle </h3>
      <b> won most of Man of the Match Awards</b>
      <p>Over the years, the league has been a spectator to several spectacular innings and terrific bowling spells which changed the tide of the match altogether.
         There have been quite a few players both Indian and Overseas who turned out to be quite the match winners.</p>
    </div>
    <div class="col-md-12 col-lg-6">
      <BarChart
      :data="motm"
      :colorScheme="'schemeAccent'"
      :yDomain="[18, 0]"
      :xRange="xRange"
       />
    </div>
	</div>
</template>

<script>
import motm from "../assets/motm.json";

export default {
  name: "MotmPanel",
  components: {
    BarChart: () => import("./BarChart.vue")
  },
  data() {
    return {
      motm,
      xRange: [0, 400]
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "orientationchange",
        this.detectOrientationChange
      );
    });
  },
  created() {
    this.detectOrientationChange();
  },
  methods: {
    detectOrientationChange() {
      // switch (window.orientation) {
      //   case 0:
      //     // landscape
      //     this.xRange = [0, 250];
      //     break;
      //   default:
      //     // portrait
      //     this.xRange = [0, 400];
      //     break;
      // }

      if (window.screen.width > 767) {
        this.xRange = [0, 400];
      } else {
        this.xRange = [0, 250];
      }
    }
  }
};
</script>

<style>
#motmpanel {
  margin-bottom: 20px;
  border-bottom: 1px grey solid;
}
</style>
